const CompanyFormatHelper = {
  getLabelDeRazaoSocialOrNmCompleto: option => {
    return Boolean(option.deRazaoSocial) ? option.deRazaoSocial : option.nmCompleto;
  }
}

export default CompanyFormatHelper
